module.exports = __webpack_public_path__ + "img/dropped-image-6.548ee90a.png";